export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9610.10d38d39.jpg";